"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Logger_1 = __importDefault(require("./Logger"));
class Bridge {
    constructor() {
        this.events = new Map();
        window.addEventListener("message", (event) => {
            // Check the origin of the data!
            if (event.origin.startsWith("http://localhost:3001") === false &&
                event.origin.startsWith("https://reeach-maker-test") === false &&
                event.origin.startsWith("https://maker.reeach.com") === false) {
                // The data has been sent from an unexpected domain.
                // You should handle this error.
                return;
            }
            Logger_1.default.logDebug("Message received" + JSON.stringify(event));
            let data = event.data;
            let eventName = data.eventName;
            let payload = data.payload;
            if (this.events.has(eventName)) {
                let callbacks = this.events.get(eventName);
                callbacks.forEach((callback) => {
                    callback(payload);
                });
            }
            else {
                console.warn(`Event ${eventName} has no listeners`);
            }
        });
    }
    /**
     * Add event listener
     *
     * @param eventName
     * @param callback
     */
    on(eventName, callback) {
        if (!this.events.has(eventName)) {
            this.events.set(eventName, []);
        }
        this.events.get(eventName).push(callback);
    }
    /**
     * Remove event listener
     *
     * @param eventName
     * @param callback
     * @returns
     */
    off(eventName, callback) {
        if (!this.events.has(eventName)) {
            return;
        }
        let callbacks = this.events.get(eventName);
        let index = callbacks.indexOf(callback);
        if (index > -1) {
            callbacks.splice(index, 1);
        }
    }
    fire(eventName, payload) {
        window.parent.postMessage({
            eventName,
            payload,
        }, "*");
    }
}
exports.default = Bridge;
//# sourceMappingURL=Bridge.js.map